function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M0 85.34h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M512 85.334v166.69L0 256.175V85.334z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M315.362 300.525L256 293.104l-59.362 7.421v-89.044h118.724z"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 263.427,
  r: 29.682,
  fill: "#0052b4"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 263.427,
  r: 14.84,
  fill: "#a2001d"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M233.739 226.321h44.522L256 248.582z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M248.576 241.166h14.84v44.522h-14.84z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M279.746 281.232h-47.492l-35.616 19.293h118.724z"
});

const SvgHaiti = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHaiti, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/haiti.1065c132.svg";
export { ForwardRef as ReactComponent };